import { motion } from "framer-motion";

export default function PageLoader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">

        {/* Logo / Brand */}
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-2xl font-semibold tracking-tight text-gray-900"
        >
          Handpreneur
        </motion.div>

        {/* Loading Bar */}
        <div className="relative w-56 h-[3px] overflow-hidden rounded-full bg-gray-200">
          <motion.div
            className="absolute left-0 top-0 h-full w-1/3 rounded-full bg-black"
            animate={{ x: ["-40%", "140%"] }}
            transition={{
              repeat: Infinity,
              duration: 1.2,
              ease: "easeInOut",
            }}
          />
        </div>

        {/* Loading Text */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.6 }}
          transition={{ delay: 0.3 }}
          className="text-sm text-gray-500"
        >
          Loading experience…
        </motion.p>
      </div>
    </div>
  );
}
